import {Prettify} from '@/utils/Prettify'

export interface User
{
    id: number
    username: string
    display_name: string
    password: string
    role: string
    roleLabel?: string
}

export type UserDraft = Prettify<Partial<User> & {
    username: string
    password: string
    display_name: string
    role: string
}>

export function createUser(): UserDraft {
    return {
        id: undefined,
        username: '',
        password: '',
        display_name: '',
        role: '',
    }
}

export const ROLE_ADMIN = 'admin'